import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH CHANNEL LOGO_INVERTED FILES TO EDIT ********************
export const fetchChannelLogoInverted = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_CHANNEL_LOGO_INVERTED_FILES_LOADING,
			payload: true
		});

		const response = await services.get(
			`/assets/${id}/list?model_type=channel&collection=logo_inverted`
		);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_CHANNEL_LOGO_INVERTED_FILES_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_CHANNEL_LOGO_INVERTED_FILES_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
